// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"9d8193d9","236":"53cab054","280":"a50b96b8","359":"a0aa4684","444":"c7d1dc34"}[chunkId] + ".css";
};